// extracted by mini-css-extract-plugin
module.exports =  {"page":"AgentTypePage__page--q1"};